export default __webpack_public_path__ + "static/media/rfidCsvExample.d82ab455.png";